import React, { useEffect, useState } from 'react'
import AllRoutes from '../nametitle/AllRoutes'
import { LoadAllEvent } from '../actions/Activites/Evenement'
import LoaderBootStrap from '../components/admin/dasboard/LoaderBootStrap'

const EvenementPage = () => {
  const [EventList, setEventList] = useState([])

  useEffect(() => {
    LoadAllEvent(setEventList)
  }, [])

  return (
    <div class='w-full flex flex-row space-y-3 justify-center'>
      <div class='col-lg-8 space-y-6 mx-5 my-5'>
        <div class='py-2 '>
          <div class='text-3xl font-bold translatable'>Evenements</div>
        </div>
        <div className="mb-5">
          <div className="input-group">
            <input type="text" className="form-control p-3 translatable" placeholder="rechercher ..." />
            <button className="btn btn-primary px-4"><i className="bi bi-search"></i></button>
          </div>
        </div>
        <div class='blog-item mb-8'>
          {EventList && EventList.length > 0 ? (
            EventList.map(item => {
              return (
                <div class='rounded-2xl row g-0 bg-success overflow-hidden'>
                  <div class='col-12 col-sm-5 h-100'>
                    <img
                      class='img-fluid h-100'
                      src={`${item.coverPicture}`}
                      style={{ objectFit: 'cover' }}
                    />
                  </div>
                  <div class='col-12 col-sm-7 h-100 d-flex flex-column justify-content-center'>
                    <div class='p-4'>
                      <div class='d-flex mb-3'>
                        {/* <small className="me-3"><i className="bi bi-bookmarks me-2"></i>Web Design</small> */}
                        <small>
                          <i class='bi bi-calendar-date me-2'></i>01 Jan, 2045
                        </small>
                      </div>
                      <h5 class='text-uppercase mb-3 translatable'>
                        {item.title}
                      </h5>
                      <p className=" translatable">
                        {item.description}
                      </p>
                      <a
                        class='text-primary text-uppercase'
                        href={`/${AllRoutes.evenement}/:id`}
                      >
                        <span className="translatable">Read More</span><i class='bi bi-chevron-right'></i>
                      </a>
                    </div>
                  </div>
                </div>
              )
            })
          ) : (
            <LoaderBootStrap />
          )}
          {/* Modal View */}
        </div>
      </div>
    </div>
  )
}

export default EvenementPage
